import Lenis from 'lenis';
import {gsap} from 'gsap';
import {ScrollTrigger} from 'gsap/ScrollTrigger';

const isEmptyHash = (href) => {
  return href === '#' || href === '#0';
};

const isPageAnchor = (link) => {
  if (!link || link.hasAttribute('data-fancybox') || link.target === '_blank') {
    return false;
  }

  const hash = link.hash;

  if (!hash || hash === '#') {
    return false;
  }

  if (link.hostname !== window.location.hostname || link.pathname !== window.location.pathname) {
    return false;
  }

  return Boolean(document.getElementById(hash.slice(1)));
};

const closeHeaderMenu = () => {
  const header = document.querySelector('[data-header]');

  if (!header || !header.classList.contains('is-open')) {
    return;
  }

  const toggle = header.querySelector('[data-toggle-menu]');

  if (toggle) {
    toggle.click();
  }
};

const scrollToAnchor = (lenis, hash, immediate) => {
  const target = document.getElementById(hash.slice(1));

  if (!target) {
    return;
  }

  lenis.scrollTo(target, {
    immediate: Boolean(immediate),
  });
};

const initSmoothScroll = () => {
  const lenis = new Lenis();

  document.addEventListener('click', (evt) => {
    const link = evt.target.closest('a[href]');

    if (!link) {
      return;
    }

    if (isEmptyHash(link.getAttribute('href'))) {
      evt.preventDefault();
      return;
    }

    if (!isPageAnchor(link)) {
      return;
    }

    evt.preventDefault();
    closeHeaderMenu();

    if (window.history.pushState) {
      window.history.pushState(null, '', link.hash);
    }

    scrollToAnchor(lenis, link.hash);
  }, true);

  if (window.location.hash) {
    scrollToAnchor(lenis, window.location.hash, true);
  }

  lenis.on('scroll', ScrollTrigger.update);

  gsap.ticker.add((time) => {
    lenis.raf(time * 1000);
  });

  gsap.ticker.lagSmoothing(0);

  return lenis;
};

export {initSmoothScroll};
